class Slot {
    constructor(id) {
        this._id = id;
    }

    get id() {
        return this._id;
    }
}

class ElementIds {
    constructor() {
        this._slots = new Set();
        this._idSlot = new Map();
        this._elementSlots = new Map();
        this._slotElement = new Map();

        this._nextId = 1;
    }

    allocateSlot() {
        const initialId = this._nextId;
        let id = initialId;

        while (this._idSlot.has(id) || id === initialId) {
            id++;
            if (id >= 0x10000) id = 1;

            if (id === initialId) {
                console.warn("Ran out of element IDs");
            }
        }

        this._nextId = id;
        const slot = new Slot(id);

        this._slots.add(slot);
        this._idSlot.set(id, slot);

        return slot;
    }

    freeSlot(slot) {
        if (!this._slots.has(slot)) {
            throw new Error("Invalid slot");
        }

        const id = slot.id;

        if (this._slotElement.has(slot)) {
            const element = this._slotElement.get(slot);

            const elementSlots = this._elementSlots.get(element);
            elementSlots.delete(slot);

            if (elementSlots.size === 0) {
                this._elementSlots.delete(element);
            }
        }

        this._slots.delete(slot);
        this._idSlot.delete(slot.id);
    }

    getIdSlot(id) {
        return this._idSlot.get(id);
    }

    setSlotElement(slot, newElement) {
        const oldElement = this._slotElement.get(slot);
        if (oldElement === newElement) return;

        if (oldElement !== undefined) {
            const elementSlots = this._elementSlots.get(oldElement);
            elementSlots.delete(slot);

            if (elementSlots.size === 0) {
                this._elementSlots.delete(oldElement);
            }
        }

        if (newElement === undefined) {
            this._slotElement.delete(slot);
        } else {
            this._slotElement.set(slot, newElement);

            let elementSlots = this._elementSlots.get(newElement);

            if (!elementSlots) {
                elementSlots = new Set();
                this._elementSlots.set(newElement, elementSlots);
            }

            elementSlots.add(slot);
        }
    }

    getSlotElement(slot) {
        return this._slotElement.get(slot);
    }

    getElementSlot(element) {
        const elementSlots = this._elementSlots.get(element);
        return elementSlots && elementSlots[Symbol.iterator]().next().value;
    }
}

export default ElementIds;
